var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.673 10.94a1.173 1.173 0 10-.176-2.34 1.173 1.173 0 00.176 2.34zM10.064 10.943a1.173 1.173 0 100-2.346 1.173 1.173 0 000 2.346zM14.503 10.941a1.173 1.173 0 10.243-2.333 1.173 1.173 0 00-.243 2.333z",
    fill: "#fff"
  })));
}
export default SvgSeeMore;